"use client";

import Link from "next/link";
import { getLocalStorage, setLocalStorage } from "@/src/lib/storage-helper";
import { useState, useEffect } from "react";
import { useTranslation } from "@/app/i18n/client";

export default function CookieBanner() {
  const { t } = useTranslation("common");
  const [cookieConsent, setCookieConsent] = useState(false);

  useEffect(() => {
    const storedCookieConsent = getLocalStorage("cookie_consent", null);

    setCookieConsent(storedCookieConsent);
  }, [setCookieConsent]);

  useEffect(() => {
    const newValue = cookieConsent ? "granted" : "denied";

    window.gtag("consent", "update", {
      analytics_storage: newValue,
      ad_storage: newValue,
      ad_user_data: newValue,
      ad_personalization: newValue,
    });

    setLocalStorage("cookie_consent", cookieConsent);
  }, [cookieConsent]);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0
                  z-50 mx-auto my-10 flex 
                  max-w-max flex-col items-center justify-between gap-4 rounded-lg bg-gray-700 px-3 py-3  
                  shadow sm:flex-row md:max-w-screen-sm md:px-4
                  ${cookieConsent !== null ? "hidden" : "flex"}`}
    >
      <div className="text-center text-white">
        <Link href="/privacy-policy">
          <p>
            {t("cookieBanner.weUse")}
            <span className="font-bold"> cookies </span>
            {t("cookieBanner.onOurSite")}.
          </p>
        </Link>
      </div>

      <div className="flex gap-2">
        <button
          className="rounded-md border-gray-900 px-5 py-2 text-white"
          onClick={() => setCookieConsent(false)}
        >
          {t("cookieBanner.decline")}
        </button>
        <button
          className="rounded-lg bg-gray-900 px-5 py-2 text-white"
          onClick={() => setCookieConsent(true)}
        >
          {t("cookieBanner.allow")}
        </button>
      </div>
    </div>
  );
}
